export default "__VITE_ASSET__Dikb3JT___"